export const RESET_PASSWORD_ATTEMPT = 'RESET_PASSWORD_ATTEMPT';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const RESET_PASSWORD_CLEAR_STATE = 'RESET_PASSWORD_CLEAR_STATE';
export const CLEAR_STATE = 'CLEAR_STATE';
